<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="7">
        <div>
          <v-row class="px-3">
            <span class="color-grey header font-weight-bold">Topics</span>
            <v-spacer></v-spacer>
            <router-link to="/dashboard/help_center/topics">
              <span class="color-blue sub-header font-weight-bold">View All Topics</span>
            </router-link>
          </v-row>
          <v-row class="mt-3">
            <v-col v-for="i in limit" v-show="loading" cols="12" md="6" class="pt-0">
              <v-skeleton-loader :loading="loading" transition="scale-transition" type="article">
              </v-skeleton-loader>
            </v-col>
            <TopicCard v-if="topics.length > 0 && !loading" v-for="topic in topics" size="6" :topic_id="topic.sys.id" :loading="loading" :icon="topic.fields.icon" :topic_title="topic.fields.name" :articles="topic.fields.articles"></TopicCard>
            <div v-if="topics.length === 0 && !loading">
              <span class="color-grey text px-4">No Topics.</span>
            </div>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" md="5">
        <CommonQuestionsCard></CommoNQuestionsCard>
        <v-card v-show="loading" class="ml-3 mt-3">
          <v-skeleton-loader :loading="loading" transition="scale-transition" type="article">
          </v-skeleton-loader>
        </v-card>
        <v-card v-if="!loading" style="background:white;" class="ml-3 pt-2 mt-3">
          <v-card-subtitle class="pb-0">
            <b>Can't find what you're looking for ?</b>
            <p>In cases where you couldn't find what you're looking for here, do contact our help support!</p>
          </v-card-subtitle>
          <v-card-actions class="pb-4 pr-4">
            <v-spacer></v-spacer>
            <a href="/dashboard/inbox?support_channel=true">
              <v-btn style="color: white;" small color="blue">Contact Us</v-btn>
            </a>
          </v-card-actions>
        </v-card>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TopicCard from './TopicCard.vue'
import CommonQuestionsCard from './CommonQuestionsCard.vue'

export default {
  components: { TopicCard, CommonQuestionsCard },
  data: () => ({
    loading: true,
    limit: 6
  }),
  created() {
    this.$store.dispatch('getTopics', 6).then(() => {
      this.loading = false
    })
  },
  computed: {
    ...mapGetters([
      'topics',
      'commonQuestions'
    ])
  }
}
</script>

<style lang="css" scoped>
</style>
